import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../contexts/auth";
import service from "../service";

const MessageTemplatesContext = createContext();

export const MessageTemplatesProvider = ({ children }) => {
  const [templateArray, setTemplateArray] = useState([]);
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn) readAllTemplates();
  }, [isLoggedIn]);

  const readAllTemplates = async () => {
    try {
      const templates = await service.getMessageTemplates();
      setTemplateArray(templates);
      return templates;
    } catch (error) {
      console.error("Failed to fetch message templates:", error);
    }
  };

  return (
    <MessageTemplatesContext.Provider value={{ templateArray, setTemplateArray, readAllTemplates }}>
      {children}
    </MessageTemplatesContext.Provider>
  );
};

export const useMessageTemplates = () => {
  return useContext(MessageTemplatesContext);
};
